export const lastMileValidItemsType = {
  REFUND_APPROVED_ITEMS: 'REFUND_APPROVED_ITEMS',
  SELECTED_ITEMS: 'SELECTED_ITEMS',
  ALL_ITEMS: 'ALL_ITEMS',
};

export const lastMileRefundAmountType = {
  VALID_ITEMS_FULL_REFUND: 'VALID_ITEMS_FULL_REFUND',
  SHIPPING_ON_FULL_ORDER: 'SHIPPING_ON_FULL_ORDER',
  NO_REFUND_DATA_NEEDED: 'NO_REFUND_DATA_NEEDED',
};

export const lastMileSupportedOrderingSystems = {
  CUSTOM_RBI: 'custom_rbi',
  SHOPIFY: 'shopify',
  COMMON: 'common',
};
